export default {
  formId: "drugsForm",
  formField: {
    pharmacyManagersTable: {
      name: "pharmacyManagersTable",
      requiredErrorMsg: "All Pharmacy Managers fields are required",
    },
    drugsTable: {
      name: "drugsTable",
      requiredErrorMsg: "All Drugs fields are required",
    },
    table: {
      name: "table",
      requiredErrorMsg: "All Plans fields are required",
    },
    group: {
      name: "group",
    },
  },
};
